<template>
	<theme-header />
	
	<router-view/>

	<theme-footer />
</template>

<script>
import ThemeHeader from '@/components/common/ThemeHeader.vue';
import ThemeFooter from '@/components/common/ThemeFooter.vue';

export default {
	components: {
		ThemeHeader,
		ThemeFooter
	}

}
</script>
